import { ListingModel } from 'models/Listing/Listing';
import { RawListingData } from 'models/Listing/types';
import { Cloneable } from 'models/Utils/Cloneable';

export interface RawDedupListingData {
	id: string;
	listing?: RawListingData | null;
	dedup_listings?: RawListingData[];
	status: string;
	timestamps?: Record<string, any>;
	similarity_score?: Record<string, number>;
}

export class DedupListingModel extends Cloneable {
	id: string;
	listing: ListingModel | null;
	dedupListings: ListingModel[];
	status: string;
	timestamps?: Record<string, any>;
	similarityScore: Record<string, number>;

	constructor(raw?: RawDedupListingData) {
		super();
		this.id = raw?.id || '';
		this.listing = raw?.listing ? new ListingModel(raw.listing) : null;
		this.dedupListings = raw?.dedup_listings?.map((dup) => new ListingModel(dup)) || [];
		this.status = raw?.status || 'Pending';
		this.timestamps = raw?.timestamps;
		this.similarityScore = raw?.similarity_score || {};
	}

	public isPending(): boolean {
		return this.status === 'Pending';
	}

	public isApproved(): boolean {
		return this.status === 'Approved';
	}

	public isRejected(): boolean {
		return this.status === 'Rejected';
	}
}

